import { jsx as _jsx } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/TechniciansPage.module.less";
import { canDeleteFromDictionaries, canEditDictionaries, } from "@/utils/permissions";
import { Button, Card, Modal, Skeleton, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DataTable } from "@/components/DataTable";
import { Filters } from "@/components/filters";
export const TechniciansPage = observer(() => {
    const { authStore, techniciansStore } = getRootStore();
    const { dataTable, loading, filtersStore } = techniciansStore;
    const navigate = useNavigate();
    // Определяем права доступа
    const userRole = authStore.userRole;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        dataTable.setFilters(filtersStore.values);
        dataTable.loadData();
    }, [filtersStore.values]);
    const handleViewTechnician = (technicianId) => {
        if (technicianId) {
            navigate(`/technicians/${technicianId}`);
        }
        else {
            navigate("/technicians/new");
        }
    };
    const handleDeleteTechnician = (technicianId) => {
        Modal.confirm({
            title: "Удалить техника?",
            content: "Вы уверены, что хотите удалить этого техника?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: () => techniciansStore.deleteTechnician(technicianId),
        });
    };
    const columns = [
        {
            title: "ФИО",
            key: "fullName",
            sorter: true,
            dataIndex: "fullName",
            render: (_, record) => (_jsx(Button, { type: "link", onClick: () => handleViewTechnician(record.id), children: `${record.lastName} ${record.firstName} ${record.middleName || ""}`.trim() })),
        },
        {
            title: "Телефон",
            dataIndex: "phone",
            key: "phone",
            render: (text) => text || "—",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text) => text || "—",
        },
        {
            title: "Действия",
            key: "actions",
            width: 120,
            render: (_, record) => canDelete && (_jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), danger: true, size: "small", onClick: () => handleDeleteTechnician(record.id) }) })),
        },
    ];
    const dataTableConfig = {
        header: {
            title: "Техники",
            actions: canEdit ? (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => handleViewTechnician(), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0435\u0445\u043D\u0438\u043A\u0430" })) : undefined,
            extraContent: (_jsx(Filters, { filtersStore: filtersStore, title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u043F\u043E\u0438\u0441\u043A", showClearAll: true, showApplyButton: false })),
        },
        columns: columns,
        rowKey: "id",
        scroll: { x: 800 },
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return _jsx(DataTable, { store: dataTable, config: dataTableConfig });
});
export default TechniciansPage;
